import React, { useState } from 'react';
import { movableSections } from '../partCatalog';

const Sidebar = ({ items, showComponentList, setShowComponentList, handleClearDesign, showStoveMenu, setShowStoveMenu, doorAngle, setDoorAngle, hasResults, onShowResults, finalizeDisabled = false, finalizeTitle = '', selectedFireProfile = 'balanced', fireProfileOptions = [], onFireProfileChange = () => {}, customProfileName = null, onEditCustomProfile = () => {}, onFinalizeDesign, elevationFt = '', setElevationFt = () => {}, depressurizationPa = '', setDepressurizationPa = () => {}, templateOptions = [], onInsertTemplate = () => {} }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(templateOptions[0]?.value || '');

  const handleDragStart = (e, itemTemplate) => {
    e.dataTransfer.setData('item', JSON.stringify(itemTemplate));
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="sidebar">
      <div className="sidebar-section">
        <div className="sidebar-category sidebar-category-blue">Templates</div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'stretch', marginBottom: '10px' }}>
          <select
            id="template-select"
            value={selectedTemplate}
            onChange={(e) => setSelectedTemplate(e.target.value)}
            style={{ flex: 1, minWidth: 0, padding: '8px', borderRadius: '4px', border: '1px solid var(--border-strong)', background: 'var(--text-on-light-muted)', color: 'var(--text-on-dark-secondary)', fontSize: '13px' }}
          >
            {templateOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          <button
            className="insert-template-btn"
            onClick={() => onInsertTemplate(selectedTemplate)}
            disabled={!selectedTemplate}
          >
            Insert
          </button>
        </div>
      </div>
      <div className="sidebar-section">
        <div className="sidebar-category sidebar-category-blue">Elevation, Fire Profile, and Room Depressurization</div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '10px',
            fontSize: '15px',
            color: 'var(--text-on-dark-muted)',
            fontWeight: 600,
          }}
        >
          <label htmlFor="sidebar-elevation">Elevation</label>
          <input
            id="sidebar-elevation"
            type="number"
            value={elevationFt}
            onChange={(e) => setElevationFt(e.target.value)}
            style={{
              width: '70px',
              padding: '4px 6px',
              borderRadius: '4px',
              border: '1px solid var(--border-strong)',
              background: 'var(--text-on-light-muted)',
              color: 'var(--text-on-dark-secondary)',
              fontSize: '13px',
            }}
          />
          <span>ft</span>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '10px',
            fontSize: '15px',
            color: 'var(--text-on-dark-muted)',
            fontWeight: 600,
          }}
        >
          <label htmlFor="sidebar-depressurization">Room Depressurization</label>
          <input
            id="sidebar-depressurization"
            type="number"
            value={depressurizationPa}
            onChange={(e) => setDepressurizationPa(e.target.value)}
            style={{
              width: '70px',
              padding: '4px 6px',
              borderRadius: '4px',
              border: '1px solid var(--border-strong)',
              background: 'var(--text-on-light-muted)',
              color: 'var(--text-on-dark-secondary)',
              fontSize: '13px',
            }}
          />
          <span>Pa</span>
        </div>
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <label
            htmlFor="fire-profile-select"
            style={{ display: 'block', fontSize: '15px', color: 'var(--text-on-dark-muted)', marginBottom: '6px', fontWeight: 600 }}
          >
            Fire Profile
          </label>
          <select
            id="fire-profile-select"
            value={selectedFireProfile}
            onChange={(e) => onFireProfileChange(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border-strong)', background: 'var(--text-on-light-muted)', color: 'var(--text-on-dark-secondary)', fontSize: '13px' }}
          >
            {fireProfileOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          {customProfileName && (
            <div style={{ marginTop: '6px', fontSize: '12px', color: 'var(--border-subtle)' }}>
              Loaded: {customProfileName}{' '}
              <button
                type="button"
                onClick={onEditCustomProfile}
                style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', padding: 0, fontSize: '12px', textDecoration: 'underline' }}
              >
                Edit
              </button>
            </div>
          )}
        </div>
      </div>
      {movableSections.map(section => (
        <div key={section.title} className="sidebar-section">
          <div className="sidebar-category">{section.title}</div>
          <div className="sidebar-icon-grid">
            {section.components.map((component, index) => (
              <div
                key={`${section.title}-${index}`}
                draggable
                onDragStart={(e) => handleDragStart(e, component.item)}
                className="sidebar-icon-item"
                title={component.item.name}
              >
                <img
                  src={component.svgSrc}
                  alt={component.label}
                  className={`sidebar-icon-img${section.title === 'Stove Pipes' || section.title === 'Lined Masonry Chimneys' ? ' no-invert' : ''}`}
                  draggable={false}
                />
                <span className="sidebar-icon-label">{component.label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
      {hasResults && (
        <button
          className="view-results-btn"
          onClick={onShowResults}
        >
          View Results
        </button>
      )}



    </div>
  );
};

export default Sidebar;
